import React, { Fragment, useRef } from "react";
import { bool, shape } from "prop-types";
import { useDispatch, connect } from "react-redux";
import { push, goBack } from "connected-react-router";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import Notification from "pages/_components/Notification";
import Image from "pages/_components/Image";
import { ResponsiveHeader } from "pages/_components/header";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import CustomText from "pages/_components/CustomText/CustomText";
import { Col } from "react-bootstrap";
import * as i18nUtils from "util/i18n";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const StepFinishEnrolledUser = ({ isMobile, onboardingWithInvitation, business, onboardingWithEnrolledUser }) => {
    const dispatch = useDispatch();
    const formRef = useRef(null);

    const goHome = () => {
        dispatch(onboardingActions.setOnboardingWithEnrolledUser(false));
        dispatch(push("/"));
    };

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const formikProps = {
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: () => Yup.object().shape({}),
        onSubmit: () => {
            goHome();
        },
    };
    return (
        <Fragment>
            <Notification scopeToShow="login" />
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                />
            )}
            <MainContainer>
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText
                            text={i18nUtils.get(
                                "onboarding.enrolled.user.stepFinish.1",
                                "¡Felicitaciones! Terminaste la validación",
                            )}
                        />
                    </h1>
                </Col>
                <div className="illustration text-center">
                    <Image
                        src={
                            onboardingWithInvitation
                                ? "figma/illustrations/onboarding9.svg"
                                : "figma/illustrations/onboarding3.svg"
                        }
                        className="svg-image logo"
                    />
                </div>
                <div className="box box-border-soft">
                    <CustomText
                        text={`${i18nUtils.get(
                            "onboarding.enrolled.user.stepFinish.2",
                            "Ahora podés operar en BiBank con la empresa",
                        )} ${business?.name}`}
                    />
                </div>
                <Formik {...formikProps} ref={formRef}>
                    {() => (
                        <Form className="above-the-fold" ref={formRef}>
                            <div className="form-actions" style={{ paddingTop: "0" }}>
                                <Button bsStyle="primary" defaultLabelText="Finalizar" type="submit" block />
                            </div>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </Fragment>
    );
};

StepFinishEnrolledUser.propTypes = {
    isMobile: bool.isRequired,
    onboardingWithInvitation: bool.isRequired,
    onboardingWithEnrolledUser: bool.isRequired,
    business: shape({}),
};

StepFinishEnrolledUser.defaultProps = {
    business: {},
};

const mapStateToProps = (state) => ({
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
    business: onboardingSelectors.getBusiness(state),
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
});

export default connect(mapStateToProps)(StepFinishEnrolledUser);
